import { useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import ReactCrop from "react-image-crop";

import "react-image-crop/dist/ReactCrop.css";

function ImageCroper({ image, onCancel, onComplete, loading }) {
    const imgRef = useRef(null);
    const [completedCrop, setCompletedCrop] = useState(null)
    const [crop, setCrop] = useState({
        unit: "%",
        width: "100",
        height: "100",
        x: 0,
        y: 0,
    });

    const onCropChange = (newCrop, percentCrop) => {
        setCrop(percentCrop);
    };

    const styles = {
        overlay: {
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: "10"
        },
        modal: {
            width: "400px",
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "24px",
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            icon: {
                width: "20px",
                height: "20px",
                cursor: "pointer",
            },
            text: {
                lineHeight: "1",
                fontWeight: "600",
                fontSize: "18px",
                margin: "0",
            }
        },
        description: {
            fontSize: "14px",
            color: "#71717a",
            margin: "6px 0",
            lineHeight: "20px",

        },
        cropContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "16px",
            img: {
                maxWidth: "100%",
                maxHeight: "400px",
                width: "auto",
                height: "auto",
                margin: "0 auto",
            }
        },
        actions: {
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            marginTop: "16px",
            button: {
                padding: "8px 16px",
                fontSize: "14px",
                lineHeight: "20px",
                borderRadius: "6px",
                border: "none",
                fontWeight: "500",
                cursor: "pointer",
            },
            uploadBtn: {
                backgroundColor: "var(--mainColor)",
                color: "white",
            }
        }
    };

    const getCroppedImg = () => {
        try {
            const img = imgRef.current;
            if (!img) {
                console.warn("Image ref is not ready");
                return;
            }

            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            if (!ctx) {
                throw new Error("No 2D context available");
            }

            if (!completedCrop || completedCrop.width === 0 || completedCrop.height === 0) {
                console.log("No crop, using full image");
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                ctx.drawImage(img, 0, 0);
            } else {
                const scaleX = img.naturalWidth / img.width;
                const scaleY = img.naturalHeight / img.height;

                const cropX = completedCrop.x * scaleX;
                const cropY = completedCrop.y * scaleY;
                const cropWidth = completedCrop.width * scaleX;
                const cropHeight = completedCrop.height * scaleY;

                if (
                    [cropX, cropY, cropWidth, cropHeight].some(val => isNaN(val) || val < 0)
                ) {
                    throw new Error("Invalid crop dimensions");
                }

                canvas.width = completedCrop.width;
                canvas.height = completedCrop.height;

                ctx.drawImage(
                    img,
                    cropX,
                    cropY,
                    cropWidth,
                    cropHeight,
                    0,
                    0,
                    completedCrop.width,
                    completedCrop.height
                );
            }

            const croppedImageUrl = canvas.toDataURL("image/jpeg");
            onComplete(croppedImageUrl);
        } catch (error) {
            console.error("Error in getCroppedImg:", error);
            alert("Xatolik yuz berdi: " + error.message);
        }
    };

    console.trace("ImageCroper rendered");

    useEffect(() => {
        if (!image) return
        const img = imgRef.current;
        const reader = new FileReader();
        reader.onload = function (event) {
            img.src = event.target.result;
        };
        reader.readAsDataURL(image);
    }, [image]);

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div>
                    <div style={styles.header}>
                        <h2 style={styles.header.text}>Crop Image</h2>
                        <IoClose style={styles.header.icon} onClick={onCancel} />
                    </div>
                </div>
                {/* cropper */}
                <div style={styles.cropContainer}>
                    <ReactCrop crop={crop} onChange={(c, n) => { setCrop(c); onCropChange(c, n) }} onComplete={(c) => setCompletedCrop(c)}>
                        <img
                            ref={imgRef}
                            src={image.uri}
                            alt="Crop me"
                            style={styles.cropContainer.img}
                            crossOrigin="anonymous"
                        />
                    </ReactCrop>
                </div>
                <div style={styles.actions}>
                    <button onClick={onCancel} style={styles.actions.button}>Cancel</button>
                    <button disabled={loading} onClick={getCroppedImg} style={{ ...styles.actions.button, ...styles.actions.uploadBtn }}>
                        {loading ? "Uploading..." : "Upload Image"}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ImageCroper;